module.exports = __webpack_public_path__ + "static/img/DO@3x.75f59b8b.jpg";